module.exports = __webpack_public_path__ + "static/media/Schuetzenfest_Hartegasse_2007.fae72511.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/gallery/TK_aus_frueheren_jahren/Schuetzenfest_Hartegasse_2007.jpg
// module id = 554
// module chunks = 0